import { FMS_READ_SCOPE } from '#/api/fmsMgmt/fmsReadScope';
import { fetchPaymentRequestPayeeOptions } from '#/api/fmsMgmt/paymentRequest';

/**
 * 領款人 async filter options：走 FMS 領款人選項（finance `/payees` 需 `.read`；個人 `/self/payees` 需 `.self`）。
 * @param {'all' | 'self'} scope
 */
export function createPayeeFilterOptionsSearch(scope = FMS_READ_SCOPE.ALL) {
  return async function searchPayeeFilterOptions({ keyword }) {
    const result = await fetchPaymentRequestPayeeOptions({
      keyword: keyword ?? '',
      scope,
    });

    return (result.data ?? []).map((payee) => ({
      value: payee.id,
      label: [payee.accountNo, payee.name].filter(Boolean).join(' - ') || String(payee.id),
    }));
  };
}
